















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

import moment from "moment";
import _ from "lodash";
import AreaPicker from "@/components/areapicker.vue";

import OperationHistory from "@/components/operationhistory.vue";
import OnlineSetting from "./components/onlinesetting.vue";

@Component({
  components: {
    AreaPicker,
    OnlineSetting,
    OperationHistory
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  handleSubmit1() {
    this.form.validateFields(async (err: any, fieldsValue: any) => {
      if (!err) {
        // nothing to do
      }
    });
  }

  mounted() {
    // mounted
  }
}
